/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsIconDangerFilled} from '@exds/icons';
import {ExdsText} from '@exds/core';
import './ErrorQr.scss';

export default function ErrorQr() {
  return (
    <>
      <ExdsIconDangerFilled className="error-qr icon" aria-hidden color="error"  />
      <ExdsText className="text-error-qr" data-testid="testid-qr-error">QR code<br/>unavailable</ExdsText>
    </>
  );
}
